export default __webpack_public_path__ + "ff82e74f6de44a594a4e496149c8580c.png";